import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { AuthService } from '@services/auth.service';
import { AuthModal } from '@app/shared/auth-modal/auth-modal';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [AuthModal],
  // Re-use the existing modal template as-is - its backdrop fills the viewport,
  // making it work perfectly as a full-page route with zero extra CSS.
  template: `<app-auth-modal (authenticated)="onAuthenticated()"></app-auth-modal>`,
})
export class LoginPage implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit(): void {
    const saved = localStorage.getItem('pxlvd-theme') as 'pxlvd' | 'dark' | 'light' | null;
    document.body.setAttribute('data-theme', saved ?? 'pxlvd');

    // Handle Google OAuth return: user leaves /login for Google, comes back to /login
    // with a PKCE code. Supabase processes it and fires SIGNED_IN. We listen for the
    // first initialized+authenticated state and navigate away - same as onAuthenticated().
    this.auth.state$.pipe(
      filter(s => s.initialized && !!s.user),
      take(1),
      takeUntil(this._destroy$),
    ).subscribe(() => this._navigateBack());
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  onAuthenticated(): void {
    this._navigateBack();
  }

  private _navigateBack(): void {
    const stored = sessionStorage.getItem('pxlvd-auth-return');
    sessionStorage.removeItem('pxlvd-auth-return');
    this.router.navigateByUrl(stored ?? '/');
  }
}
